// roles-actions.js

// allowable actions for specific user roles
// mainly used for displaying bulk action buttons in multi-select lists

// THESE ROLES MUST EXACTLY MATCH WHAT THE BACKEND DEFINES
export const ROLE_SEARCH = 'search';
export const ROLE_READ = 'read';
export const ROLE_REVIEW_WRITE = 'review.write';
export const ROLE_SUBMITTER = 'submitter';

// fake roles
export const ROLE_TCARE_SPECIALIST = 'tcare-specialist';
export const ROLE_CONNECT_ANALYIST = 'connect-analyst';


export const ACTION_APPROVE = 'approve';
export const ACTION_REJECT = 'reject';
export const ACTION_MERGE_SERVICES = 'merge';
export const ACTION_FLAG_DUPLICATES = 'duplicates';
export const ACTION_SAVE_TO_COLL = 'save-to-coll';
export const ACTION_FLAG_DISLIKE = 'flag-dislike';
export const ACTION_REMOVE_DISLIKE = 'remove-dislike';

// import {ROLE_SEARCH, ROLE_READ, ROLE_WRITE, ROLE_REVIEW_WRITE, ROLE_SUBMITTER} from 'roles-actions.js';
// import {ACTION_APPROVE, ACTION_REJECT, ACTION_MERGE_SERVICES, ACTION_FLAG_DUPLICATES} from 'roles-actions.js';
// import {ACTION_SAVE_TO_COLL, ACTION_FLAG_DISLIKE, ACTION_REMOVE_DISLIKE} from 'roles-actions.js';
